import React from 'react';
import { connect } from 'react-redux';
import { fetchLiveData } from 'actions/node';
import { fetchCurrentUser } from 'actions/myaccount';
import MainMenu from 'components/common/mainmenu'
import Widgets from 'components/pages/overview/widgets';
import SearchContainer from 'components/pages/overview/searchcontainer';
import StickyMenu from '../../common/stickymenu';

class OverViewContainer extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {
        this.props.dispatch(fetchLiveData());
        this.props.dispatch(fetchCurrentUser());
    }

    render() {
        return (
            <div className="overview-page">
                <StickyMenu
                    withStickyHeader={true}
                >
                    <MainMenu
                        overviewIsActive={true}
                        comparisonIsActive={false}
                        onlyLeftMenu={false}
                    />
                </StickyMenu>
                <div className="page-content">
                    <div className="overview-grid-widget overwrite--modal--depth ">
                        <Widgets tree={this.props.tree} querySettings={this.props.querySettings} allSensors={this.props.currentSensor} />
                        <SearchContainer tree={this.props.tree} querySettings={this.props.querySettings} />
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        loggedIn: state.authReducer.loggedIn,
        user: state.myAccountReducer.user,
        currentSensor: state.nodeReducer.map,
        currentNode: state.overviewReducer.currentNode,
        querySettings: state.querySettingsReducer,
        tree: state.overviewReducer.customerOverview,
        nodeMap: state.overviewReducer.nodeMap
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OverViewContainer);



// WEBPACK FOOTER //
// ./src/components/pages/overview/overviewcontainer.jsx